define('models/PostcodeModel',['underscore','ObjectModel','LocalStorage','StringSimplification'],function (_,ObjectModel,LocalStorage,Simplification) {
    //
    // Model Postcode
    //

    var PostcodeModelPrototype = {

        name:'PostcodeModel',
        idAttribute:'id_postcode',
        route:'apiPostcodeModel',
        defaults:{
            postcode:'',
        },

        initialize:function(){
            var model = this;
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(model,arguments);
            //
            if(!model.get(model.idAttribute)){
                model.attributes[model.idAttribute] = model.get('id');
            }
            // optimisation de la recherche par nom, insensible à la casse
            model.set('postcodeUpperCase',model.get('postcode').toUpperCase());
        },
        getCity:function(){
            return this.get('city');
        },
        getPostcode:function(){
            return this.get('postcode');
        },
        getLocalitySimplification:function(wrap){
            var model = this, localities = [],google_localities = model.get('google_localities');
            if(google_localities){
                localities = _(google_localities.split(', ')).map(function(c){return Simplification(c,wrap)});
            }else{
                localities = [Simplification(model.get('city'),wrap)];
            }
            return localities;
        },
        testFormatedLocality:function(formatedLocality){
            var model = this,
                regExpAttr = 'testFormatedRegExp',
                localitySimplificationRegExp = model.get(regExpAttr);
            if(!localitySimplificationRegExp){
                var s = model.getLocalitySimplification(true),
                    localitySimplificationRegExp = new RegExp(s.join('|'));
                model.set(regExpAttr,localitySimplificationRegExp);
            }
            var test = localitySimplificationRegExp.test(formatedLocality);
            return test;
        },
        getPolygons:function(){return this.get('polygons')},
        getLocationDistrict:function(lat,lng){
            var postcode = this, districts = postcode.getDistricts(),
                success;
            if(!districts) return;
            //
            _(districts).each(function(district){
                var polygons = district.polygons,
                    inDistrict = false;
                if(polygons){
                    _(polygons).each(function(polygon){
                        //
                        // original implementation
                        // see https://github.com/substack/point-in-polygon/
                        var inside = false;
                        for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
                            var xi = polygon[i].lat, yi = polygon[i].lng;
                            var xj = polygon[j].lat, yj = polygon[j].lng;

                            var intersect = ((yi > lng) != (yj > lng))
                                && (lat < (xj - xi) * (lng - yi) / (yj - yi) + xi);
                            if (intersect) inside = !inside;
                        }
                        inDistrict |= inside;
                    });
                }
                if(inDistrict){
                    success = district;
                }
            });
            return success;

        },
        isLatLngMatching:function(lat,lng){
            return !_.isUndefined(this.getLocationDistrict(lat,lng));
        },
        hasDistricts:function(){
            var district = this.getDistricts();
            return district ? district.length > 0 : false;
        },
        getDistricts:function(){
            return this.get('districts');
        },
        getDistrict:function(id_district){
            return _(this.getDistricts()).findWhere({id_district:id_district});
        }
    };

    var PostcodeModel = ObjectModel.extend(LocalStorage).extend(PostcodeModelPrototype);

    return PostcodeModel;
});
